import { interpolateHtml } from "../html";
import codeFilterTableHtml from "./code-filter-table.html";
import codeFilterSyscallHtml from "./code-filter-syscall.html";
export class Filter {
    static generateCodeFilterSyscall(syscall, coverage, conditions) {
        let uid = `uid-${Filter.uidCounter++}`;
        return interpolateHtml(codeFilterSyscallHtml, new Map([
            [`//div[@data-filtered-syscall]/@data-filtered-syscall`, syscall],
            [`//div[@data-filtered-coverage]/@data-filtered-coverage`, `any ${coverage}`],
            [`//div[@data-filtered-conditions]/@data-filtered-conditions`, `any ${conditions}`],
            [`//div[@class="code-filter-syscall-checkbox"]/input/@id`, uid],
            [`//div[@class="code-filter-syscall-checkbox"]/input/@value`, syscall],
            [`//label[@class="code-filter-syscall-name"]/@for`, uid],
            [`//label[@class="code-filter-syscall-name"]/text()`, syscall],
            [`//div[@class="code-filter-syscall-coverage"]/text()`, coverage],
            [`//div[@class="code-filter-syscall-conditions"]/text()`, conditions],
        ]));
    }
    static generateCodeFilterTable() {
        let uid = `uid-${Filter.uidCounter++}`;
        return interpolateHtml(codeFilterTableHtml, new Map([
            [`//input/@id`, uid],
            [`//label/@for`, uid]
        ]));
    }
    constructor(reachability) {
        this.reachability = reachability;
    }
    async displaySyscalls(syscalls, syskallsPromise, conditionsPromise, codeFilter) {
        let syzkalls = await syskallsPromise;
        let codeBody = codeFilter.closest('.code-body');
        let outerCodeBody = codeBody.closest('.code-body.filter-syscall[data-filter-syscall]');
        let defaultSelectedSyscallsFromParent = null;
        if (outerCodeBody) {
            defaultSelectedSyscallsFromParent = new Set(outerCodeBody.dataset.filterSyscall?.split(' '));
        }
        let defaultUnselectedSyscallsFromChildren = new Set();
        codeBody.querySelectorAll('.code-body .code-filter-syscall-checkbox-input:not(:checked)').forEach(input => defaultUnselectedSyscallsFromChildren.add(input.value));
        let syscallMap = new Map();
        const updateCheckboxes = () => {
            codeBody.dataset.filterSyscall = [...syscallMap.entries()].filter(v => v[1].checked && v[1].checkVisibility()).map(v => v[0]).join(' ');
        };
        const changeHandler = (e) => {
            let eventElement = e.target;
            let checkboxElement = syscallMap.get(eventElement.value);
            if (checkboxElement) {
                checkboxElement.checked = eventElement.checked;
            }
            updateCheckboxes();
        };
        if (codeFilter.children.length) {
            this.clearSyscallFilter(codeBody, codeFilter);
        }
        else {
            this.applySyscallFilter(syscalls, syzkalls, await conditionsPromise, codeBody, codeFilter, syscallMap, updateCheckboxes, changeHandler, defaultSelectedSyscallsFromParent, defaultUnselectedSyscallsFromChildren);
        }
    }
    clearSyscallFilter(codeBody, codeFilter) {
        codeBody.classList.remove('filter-syscall');
        codeFilter.replaceChildren();
        Filter.changeAbortControllers.get(codeBody)?.abort();
    }
    applySyscallFilter(syscalls, syzkalls, conditions, codeBody, codeFilter, syscallMap, updateCheckboxes, changeHandler, defaultSelectedSyscallsFromParent, defaultUnselectedSyscallsFromChildren) {
        codeBody.classList.add('filter-syscall');
        let codeFilterTableFragment = Filter.generateCodeFilterTable();
        let codeFilterTable = codeFilterTableFragment.querySelector('.code-filter-table');
        codeFilter.replaceChildren(codeFilterTableFragment);
        codeFilterTable.querySelectorAll('select').forEach(select => select.addEventListener('change', (e) => {
            codeFilterTable.setAttribute(`data-filter-${select.name}`, `${select.value}`);
            updateCheckboxes();
        }));
        codeFilterTable.querySelector('.code-filter-header input')?.addEventListener('change', (e) => {
            let master = e.target;
            codeFilterTable.querySelectorAll('.code-filter-syscall-checkbox-input').forEach(elem => {
                const input = elem;
                if (elem.checkVisibility()) {
                    input.checked = master.checked;
                }
            });
            updateCheckboxes();
        });
        for (let syscall of syscalls) {
            const hasCoverage = syzkalls.some(s => s.syscall == syscall.syscall);
            const syzPrograms = syzkalls.filter(s => s.syscall == syscall.syscall).map(s => s.prog_id);
            const filteredConditions = conditions.filter(s => s.syscall == syscall.syscall);
            let conditionSummarySet = new Set;
            filteredConditions.forEach((entry) => {
                conditionSummarySet.add(entry.condition_type[0]);
            });
            let conditionSummary = [...conditionSummarySet];
            let syscallFragment = Filter.generateCodeFilterSyscall(syscall.syscall, hasCoverage ? 'yes' : 'no', conditionSummary.join(' '));
            let syscallCheckbox = syscallFragment.querySelector('input');
            let syzkallerLink = syscallFragment.querySelector('.code-filter-syscall-coverage');
            let conditionLink = syscallFragment.querySelector('.code-filter-syscall-conditions');
            syscallMap.set(syscall.syscall, syscallCheckbox);
            codeFilterTable.appendChild(syscallFragment);
            if (defaultSelectedSyscallsFromParent) {
                syscallCheckbox.checked = defaultSelectedSyscallsFromParent.has(syscall.syscall);
            }
            syscallCheckbox.checked = syscallCheckbox.checked && !defaultUnselectedSyscallsFromChildren.has(syscall.syscall);
            if (hasCoverage) {
                syzkallerLink.classList.add('code-filter-syscall-coverage-link');
                syzkallerLink.addEventListener('click', e => {
                    this.reachability.displaySyzkallerPrograms(syzPrograms);
                });
            }
            if (conditionSummary.length) {
                conditionLink.classList.add('code-filter-syscall-condition-link');
                conditionLink.addEventListener('click', e => {
                    this.reachability.displayConditions(filteredConditions);
                });
            }
        }
        updateCheckboxes();
        let abortController = new AbortController;
        Filter.changeAbortControllers.set(codeBody, abortController);
        codeBody.addEventListener('change', changeHandler, {
            signal: abortController.signal
        });
    }
}
Filter.changeAbortControllers = new WeakMap();
Filter.uidCounter = 0;
